import React from "react";

import isIntuit from "Intuit/isIntuit";

import { Surface as CobaltSurface, SurfaceSection as CobaltSurfaceSection, SurfaceHeader as CobaltSurfaceHeader } from "Cobalt/Surface";
import { Card, CardSection, CardHeader } from "Common/Card";

import { useThemeContext } from "./Context";

export const Surface = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return isIntuit() && intuit ? (
    <Card p={0} {...rest} {...intuitProps}>
      {children}
    </Card>
  ) : cobalt ? (
    <CobaltSurface {...rest} {...cobaltProps}>
      {children}
    </CobaltSurface>
  ) : (
    <Card p={0} {...rest} {...classicProps}>
      {children}
    </Card>
  );
};

export const SurfaceSection = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return isIntuit() && intuit ? (
    <CardSection {...rest} {...intuitProps}>
      {children}
    </CardSection>
  ) : cobalt ? (
    <CobaltSurfaceSection {...rest} {...cobaltProps}>
      {children}
    </CobaltSurfaceSection>
  ) : (
    <CardSection {...rest} {...classicProps}>
      {children}
    </CardSection>
  );
};

export const SurfaceHeader = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return isIntuit() && intuit ? (
    <CardHeader {...rest} {...intuitProps}>
      {children}
    </CardHeader>
  ) : cobalt ? (
    <CobaltSurfaceHeader {...rest} {...cobaltProps}>
      {children}
    </CobaltSurfaceHeader>
  ) : (
    <CardHeader {...rest} {...classicProps}>
      {children}
    </CardHeader>
  );
};
